import $ from "jquery";

/*------------------------------------*\
    FEEDBACK PROGRESS
\*------------------------------------*/
var feedback = require('../../site/_data/site');

class FeedbackProgress {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.checkSectionComplete();
    }

    checkSectionComplete() {
        // Loop through feedback sections and check against section keys in local storage by index
        feedback.consultation.themes.forEach((section, index) => {          
            if (JSON.parse(localStorage.getItem('0' + (index + 1) + '-section'))) {
                console.log((index + 1) + "-complete");

                // Show 'section complete' message
                $("#section-" + (index + 1) + "-complete").removeClass("d-none");
                $("#section-" + (index + 1) + "-complete").text("✓");
            }
        })
        
        // Check if user details have been completed
        if(JSON.parse(localStorage.getItem('your-details-section'))) {
            // Show completed icon in feedback nav
            $("#your-details-complete").text("✓");
        }
    }

}

export default FeedbackProgress;